module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.show) ? _c('div', {
    class: {
      'weui-skin_android': _vm.android
    }
  }, [_c('div', {
    staticClass: "weui-mask",
    staticStyle: {
      "opacity": "1"
    },
    on: {
      "click": _vm.cancel
    }
  }), _vm._v(" "), _c('div', {
    class: [{
      'weui-actionsheet_toggle': _vm.toggleIt
    }, 'weui-actionsheet']
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [_vm._t("default")], true), _vm._v(" "), (!_vm.noCancel) ? _c('div', {
    staticClass: "weui-actionsheet__action"
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-43f5d100!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/action-sheet.vue
// module id = 237
// module chunks = 0